// import config from 'config';

import { useBreakpoint } from '~/techstyle-shared/react-components';

const useNumGridCols = () => {
  // const gridColumnSettings = config.get('public.brand.gridColumnSettings');

  // original is 960px but causes products to overlap
  // consider adding padding to card and virtual row if we revert to 960px
  const { matches: twoColBreakpoint } = useBreakpoint('(max-width: 490px)');
  const { matches: threeColBreakpoint } = useBreakpoint('(max-width: 1023px)');

  if (twoColBreakpoint) {
    return 2;
  }

  if (threeColBreakpoint) {
    return 3;
  }

  return 4;
};

export default useNumGridCols;
